export const enGB_menu = {
	'app.menu.dashboard':'统计',
	'app.menu.dashboard.learn':'学习统计',
	'app.menu.dashboard.preach':'宣讲统计',

	'app.menu.learn': '学习任务管理',
	'app.menu.learn.plan': '年度学习计划',
	'app.menu.learn.manager': '学习任务管理',
	'app.menu.learn.check': '自主上报审核',
	'app.menu.learn.state': '学习情况查看',

	'app.menu.preach': '理论宣讲管理',
	'app.menu.preach.team': '宣讲情况查看',
	// 'app.menu.preach.check': '宣讲自主上报',
	'app.menu.preach.plan': '年度宣讲计划',
	'app.menu.preach.task_check': '宣讲任务查看',


	'app.menu.material': '学习资料',
	'app.menu.material.manager': '学习资料管理',


	'app.menu.account': '账号管理',
	'app.menu.account.manager': '学习账号管理',
	'app.menu.account.config': '预警设置',


	'app.menu.unit.dashboard':'统计',
	'app.menu.unit.dashboard.learn':'学习统计',
	'app.menu.unit.dashboard.preach':'宣讲统计',
	'app.menu.unit.learn': '理论学习',
	'app.menu.unit.learn.plan':'年度学习计划',
	'app.menu.unit.learn.task.report':'学习任务上报',
	'app.menu.unit.learn.report':'自主学习上报',
	'app.menu.unit.preach':'理论宣讲',
	'app.menu.unit.preach.team':'宣讲队伍建设',
	'app.menu.unit.preach.task':'理论宣讲任务',
	'app.menu.unit.preach.report':'宣讲自主上报',
	'app.menu.unit.material':'学习资料',
	'app.menu.unit.material.manager':'学习宣讲资料',
}
